import { Actions } from './articlesGestionActions';

/**
 * Etat initial
 */
const initialState = {
    suggestions: {
        items: [],
        isLoading: false,
        value: '',
        selected: null
    }
};

/**
 * Reducer pour le domaine "articlesGestion"
 */
const reducer = (namespace) => (state = initialState, action) => {

    switch (action.type) {
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_ARTICLE_GESTION_REQUEST}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: true }
            };
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_ARTICLE_GESTION_SUCCESS}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [...action.articlesGestion], isLoading: false }
            };
        case `${namespace}/${Actions.FETCH_SUGGESTIONS_ARTICLE_GESTION_FAILURE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, isLoading: false, error: action.error }
            };
        case `${namespace}/${Actions.CLEAR_SUGGESTIONS_ARTICLE_GESTION}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, items: [], isLoading: false }
            };
        case `${namespace}/${Actions.SET_ARTICLE_GESTION_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: action.value, selected: action.suggestion }
            };
        case `${namespace}/${Actions.CLEAR_ARTICLE_GESTION_VALUE}`:
            return {
                ...state,
                suggestions: { ...state.suggestions, value: '', selected: null }
            };

        default:
    }

    return state;
};

export default reducer;